import { css } from "@emotion/react";

export const dropdownBtnTransparent = css`
  border: 0;
  background-color: transparent;
`;

export const dropdownContent = css`
  max-height: 15rem;
`;

export const dropDownAlignment = css`
  margin-right: -0.5rem;
`;
